/* import __COLOCATED_TEMPLATE__ from './ember-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();